import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';
import type { CreateRoleRequest } from '../types/role';

/**
 * POST /api/eraf/roles — 역할 신규 생성
 */
export function useCreateRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateRoleRequest) => roleApi.create(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['role-management', 'list'] });
    },
  });
}
